import { Collapse } from "antd";
import moment from "moment";
import IndexActions from "./indexActions";

const { Panel } = Collapse;

export default function ObjetivosAccordion({ objetivos, getObjetivos, planCollaborators }) {
	const status = [
		{
			value: "ANDAMENTO",
			label: "Em Andamento",
			icon: "bx bx-right-arrow",
			color: "#556ee6",
		},
		{
			value: "STANDBY",
			label: "Standby",
			icon: "bx bx-stop-circle",
			color: "#74788d",
		},
		{ value: "OK", label: "Ok", icon: "bx bx-like", color: "#34c38f" },
		{
			value: "CANCELADO",
			label: "Cancelado",
			icon: "bx bx-block",
			color: "#f46a6a",
		},
	];

	// Ordenar objetivos por prazo (crescente)
	const objetivosOrdenados = objetivos.sort((a, b) => {
		const dataA = new Date(a.deadline);
		const dataB = new Date(b.deadline);
		return dataA - dataB;
	});

	return (
		<Collapse accordion style={{ width: "100%" }}>
			{objetivosOrdenados.map((objetivo) => {
				// Ações que entram no cálculo (exclui canceladas, igual overdueActions)
				const actionsThatCount = objetivo.actions.filter(
					(action) => action.status !== "CANCELADO",
				);
				const totalActions = actionsThatCount.length;
				const completedActions = actionsThatCount.filter(
					(action) => action.status === "OK",
				).length;
				const progressPercentage =
					totalActions > 0
						? parseFloat(
								(
									(completedActions / totalActions) *
									100
								).toFixed(2),
						  )
						: 0;
				// Calcular ações em atraso
				const overdueActions = objetivo.actions.filter(
					(action) =>
						moment(action.deadline).isBefore(moment(), "day") &&
						action.status !== "OK" &&
						action.status !== "CANCELADO" &&
						action.status !== "STANDBY",
				).length;

				return (
					<Panel
						key={objetivo.id}
						header={
							<div>
								{objetivo.objective} | Prazo:{" "}
								{new Date(objetivo.deadline).toLocaleDateString(
									"pt-BR",
									{
										timeZone: "UTC",
									},
								)}{" "}
								{objetivo.responsible?.lastname ? `| Responsável: ${objetivo.responsible.lastname} ` : ""}| {objetivo.actions.length} Ações |{" "}
								{progressPercentage}% |{" "}
								{overdueActions > 0
									? `${overdueActions} em atraso | `
									: ""}
								<span
									style={{
										backgroundColor: status.find(
											(s) => s.value === objetivo.status,
										)?.color,
									}}
									className="badge rounded-pill text-white"
								>
									<i
										className={
											status.find(
												(s) =>
													s.value === objetivo.status,
											)?.icon
										}
									></i>{" "}
									{status.find(
										(s) => s.value === objetivo.status,
									)?.label || "Status não encontrado"}
								</span>
							</div>
						}
					>
						<IndexActions
							obj_actions={objetivo}
							getObjetivos={getObjetivos}
							planCollaborators={planCollaborators}
						/>
					</Panel>
				);
			})}
		</Collapse>
	);
}
